import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Scrollbars } from "react-custom-scrollbars";
import moment from "moment";
import { CommonStore } from "Store";
import { store, GetFilter, GetPostsFromSubs } from "../store";
import { queryGetSchedulerPost, queryGetSchedulerPostSent } from "Apollo";
import LoadingPanel from "module-common/LoadingPanel";
import Row from "./Row";

const ListGraphql = compose(
  graphql(queryGetSchedulerPost, {
    skip: props => props.isSent
    //options: { pollInterval: 60000 }
  }),
  graphql(queryGetSchedulerPostSent, {
    skip: props => !props.isSent
    //options: { pollInterval: 60000 }
  })
)(
  observer(
    class ListView extends Component {
      states = observable({ loadingPagination: false });

      preprocessData = () => {
        // preprocess data
        const { data: { getSchedulerPost, getSchedulerPostSent } } = this.props;
        const { isSentTab } = store;
        const maps = new Map();

        // pick source of query data
        const posts = isSentTab ? getSchedulerPostSent : getSchedulerPost;

        // collect rows from query
        for (const { node: row } of posts.edges) {
          maps.set(row.id, {
            key: row.id,
            id: row.id,
            editing: row.id === store.updateId,
            companyChannelHandler: row.companyChannelHandler,
            channel: row.channel,
            content: row.content,
            sentBy: row.sentBy,
            imageUrl: row.media ? row.media.url : null,
            specificType: row.specificType,
            dateForPost: moment(row.dateForPost),
            dateCreated: moment(row.dateCreated)
          });
        }

        // combine with rows from subs
        const subs = GetPostsFromSubs(isSentTab);
        for (const row of subs) {
          if (
            !isSentTab &&
            moment(row.dateForPost).isBefore(CommonStore.serverTime)
          ) {
            continue;
          }

          if (row.isActive) {
            maps.set(row.id, {
              key: row.id,
              id: row.id,
              editing: row.id === store.updateId,
              companyChannelHandler: row.companyChannelHandler,
              channel: row.channel,
              content: row.content,
              sentBy: row.sentBy,
              imageUrl: row.media ? row.media.url : null,
              specificType: row.specificType,
              dateForPost: moment(row.dateForPost),
              dateCreated: moment(row.dateCreated)
            });
          } else {
            maps.delete(row.id);
          }
        }

        // sort by date
        const rows = [...maps.values()].sort(
          (a, b) => new Date(a.dateForPost) - new Date(b.dateForPost)
        );

        return rows;
      };

      render() {
        const { data: { loading } } = this.props;

        if (loading) {
          return <LoadingPanel />;
        } else {
          const rows = this.preprocessData();
          return (
            <Scrollbars
              ref={ref => (this.scroller = ref)}
              onScrollFrame={this.onScrollFrame}
            >
              {rows.map(row => <Row {...row} />)}
            </Scrollbars>
          );
        }
      }

      onScrollFrame = event => {
        // detect if on bottom scroll
        if (event.top === 1) {
          this.onEndReached();
        }
      };

      onEndReached = async () => {
        const {
          data: { fetchMore, getSchedulerPost, getSchedulerPostSent }
        } = this.props;
        const { isSentTab } = store;
        const posts = isSentTab ? getSchedulerPostSent : getSchedulerPost;

        // make sure we are not on top most data
        if (posts && posts.edges.length > 0) {
          if (!this.states.loadingPagination) {
            this.states.loadingPagination = true;
            const length = posts.edges.length;
            const cursor = posts.edges[length - 1].cursor;
            await fetchMore({
              variables: {
                after: cursor
              },
              updateQuery: (prevResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prevResult;
                if (isSentTab) {
                  const result = Object.assign(
                    {},
                    prevResult.getSchedulerPostSent,
                    {
                      edges: [
                        ...prevResult.getSchedulerPostSent.edges,
                        ...fetchMoreResult.getSchedulerPostSent.edges
                      ]
                    }
                  );
                  return { getSchedulerPostSent: result };
                } else {
                  const result = Object.assign(
                    {},
                    prevResult.getSchedulerPost,
                    {
                      edges: [
                        ...prevResult.getSchedulerPost.edges,
                        ...fetchMoreResult.getSchedulerPost.edges
                      ]
                    }
                  );
                  return { getSchedulerPost: result };
                }
              }
            });
            this.states.loadingPagination = false;
          }
        }
      };
    }
  )
);

export default observer(
  class List extends Component {
    render() {
      const { isSentTab } = store;
      let list;
      if (isSentTab) {
        list = <ListGraphql isSent {...GetFilter()} />;
      } else {
        list = <ListGraphql {...GetFilter()} />;
      }
      return list;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-schedule/list/ListWithStoreQuery.js